export function formatPromoDiscount(
  type: 'fixed' | 'percentage' | undefined,
  value: number | undefined
): string {
  if (type === 'percentage' && typeof value === 'number') {
    return `-${String(value)}%`;
  }

  if (type === 'fixed' && typeof value === 'number') {
    return `-€${value}`;
  }

  return '';
}
